(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["feefo-reviews-native"] && !Shopify.designMode) return;
  try {
    // Feefo native reviews — progressive enhancement.
// Server renders ALL reviews visible and works fully with JS OFF (no controls
// shown, whole list visible, share links are plain anchors). With JS ON this:
//   • reveals + wires the rating filter and sort dropdowns (sort: Most recent /
//     Highest / Lowest / Most helpful),
//   • filters/reorders the ALREADY-rendered <li>s in place (no network calls),
//   • collapses to the first 5 of the CURRENT (filtered+sorted) set with a
//     "Load more reviews (N)" control that counts the filtered set only,
//   • shows an empty-state message when a filter matches 0 reviews,
//   • upgrades each share link to copy-to-clipboard with brief feedback,
//   • collapses each review's merchant reply/replies behind a
//     "Show response(s) (N)" toggle, revealed to "Hide response(s)" on click.
// Merchant replies live inside each <li>, so they move/hide with their review
// automatically under filter/sort/pagination — the reply toggle below is wired
// once at init and never touched again by render()/refresh(), so its expanded
// state rides along unchanged when appendChild relocates the <li>.
(function () {
  var STEP = 5;
  var roots = document.querySelectorAll('.feefo-reviews-native');
  for (var r = 0; r < roots.length; r++) { initRoot(roots[r]); }

  function initRoot(root) {
    var list = root.querySelector('.feefo-reviews-native__list');
    if (!list) return;
    var allItems = Array.prototype.slice.call(
      list.querySelectorAll('.feefo-reviews-native__item')
    );
    if (!allItems.length) return;

    var controls = root.querySelector('.feefo-reviews-native__controls');
    var filterSel = root.querySelector('[data-feefo-filter]');
    var sortSel = root.querySelector('[data-feefo-sort]');
    var emptyEl = root.querySelector('.feefo-reviews-native__empty');

    var shown = STEP;                 // visible count within the CURRENT set
    var current = allItems.slice();   // filtered + sorted working set
    var moreBtn = null;

    // Reduced-motion gate: when the user requests reduced motion, every animation
    // enhancement below degrades to the instant behaviour that was already verified
    // (no fades/slides). All the animation CSS is likewise wrapped in
    // `@media (prefers-reduced-motion: no-preference)`.
    var motionOK = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var reorderTimer = null;

    function ratingOf(li) { var v = parseFloat(li.getAttribute('data-rating')); return isNaN(v) ? 0 : v; }
    function tsOf(li) { var v = parseInt(li.getAttribute('data-timestamp'), 10); return isNaN(v) ? 0 : v; }
    function helpfulOf(li) { var v = parseInt(li.getAttribute('data-helpful'), 10); return isNaN(v) ? 0 : v; }

    function computeCurrent() {
      var filter = filterSel ? filterSel.value : 'all';
      var sort = sortSel ? sortSel.value : 'recent';
      current = allItems.filter(function (li) {
        if (filter === 'all') return true;
        return Math.round(ratingOf(li)) === parseInt(filter, 10);
      });
      if (sort === 'highest') {
        current.sort(function (a, b) { return ratingOf(b) - ratingOf(a) || tsOf(b) - tsOf(a); });
      } else if (sort === 'lowest') {
        current.sort(function (a, b) { return ratingOf(a) - ratingOf(b) || tsOf(b) - tsOf(a); });
      } else if (sort === 'helpful') {
        // Most helpful: helpful_votes desc, ties broken by date desc (same tiebreak
        // as the other modes). With this merchant's near-zero votes most reviews
        // tie at 0, so they simply fall back to newest-first order.
        current.sort(function (a, b) { return helpfulOf(b) - helpfulOf(a) || tsOf(b) - tsOf(a); });
      } else { // 'recent'
        current.sort(function (a, b) { return tsOf(b) - tsOf(a); });
      }
    }

    function updateMore() {
      var remaining = current.length - shown;
      if (current.length <= STEP || remaining <= 0) {
        if (moreBtn) { moreBtn.remove(); moreBtn = null; }
        return;
      }
      if (!moreBtn) {
        moreBtn = document.createElement('button');
        moreBtn.type = 'button';
        moreBtn.className = 'feefo-reviews-native__more';
        moreBtn.addEventListener('click', function () {
          var from = shown;
          shown = Math.min(shown + STEP, current.length);
          render();
          // Animate ONLY the reviews revealed by this click (indices from..shown).
          // A one-shot class, self-removed on animationend, so re-sorts/re-renders
          // later don't re-trigger it.
          if (motionOK) {
            for (var m = from; m < shown; m++) { markEntering(current[m]); }
          }
        });
        list.insertAdjacentElement('afterend', moreBtn);
      }
      moreBtn.textContent = 'Load more reviews (' + remaining + ')';
    }

    function render() {
      // Reorder the DOM to match `current` (appendChild moves existing nodes).
      for (var i = 0; i < current.length; i++) { list.appendChild(current[i]); }
      // Hide anything filtered out.
      for (var j = 0; j < allItems.length; j++) {
        if (current.indexOf(allItems[j]) === -1) { allItems[j].hidden = true; }
      }
      // Paginate within the current set only.
      for (var k = 0; k < current.length; k++) { current[k].hidden = k >= shown; }
      if (emptyEl) { emptyEl.hidden = current.length !== 0; }
      updateMore();
    }

    function refresh(resetPage) {
      if (resetPage) { shown = STEP; }
      computeCurrent();
      render();
    }

    // One-shot "just revealed" flag for a review <li> (Load-more entrance).
    function markEntering(li) {
      if (!li) { return; }
      li.classList.add('feefo-reviews-native__item--enter');
      var done = function () {
        li.classList.remove('feefo-reviews-native__item--enter');
        li.removeEventListener('animationend', done);
      };
      li.addEventListener('animationend', done);
    }

    // Filter/sort change: fade the list out, THEN reorder, THEN fade back in. The
    // reorder itself (computeCurrent + appendChild in render) is UNCHANGED — this
    // is purely a visual wrapper. refresh() always recomputes from the live select
    // values, so even if changes overlap the final state is correct. Under reduced
    // motion it reorders instantly (identical to the previously verified path).
    function applyChange() {
      if (!motionOK) { refresh(true); return; }
      if (reorderTimer) { window.clearTimeout(reorderTimer); }
      list.classList.add('feefo-reviews-native__list--fading');
      reorderTimer = window.setTimeout(function () {
        refresh(true);
        window.requestAnimationFrame(function () {
          list.classList.remove('feefo-reviews-native__list--fading');
        });
        reorderTimer = null;
      }, 150); // ≈ --animation-speed-medium (0.15s); matches the CSS fade duration
    }

    if (controls) { controls.hidden = false; }
    if (filterSel) { filterSel.addEventListener('change', applyChange); }
    if (sortSel) { sortSel.addEventListener('change', applyChange); }
    refresh(true);

    // Share / copy-link: copy review.url to clipboard, briefly show "Copied!".
    // If the Clipboard API is unavailable we do NOT preventDefault, so the plain
    // <a href target="_blank"> opens the review as the fallback.
    var shares = root.querySelectorAll('[data-feefo-share]');
    for (var s = 0; s < shares.length; s++) {
      shares[s].addEventListener('click', function (e) {
        var url = this.getAttribute('href');
        if (!url || !navigator.clipboard || !navigator.clipboard.writeText) { return; }
        e.preventDefault();
        var link = this;
        var lbl = link.querySelector('.feefo-reviews-native__share-label');
        navigator.clipboard.writeText(url).then(function () {
          if (!lbl) { return; }
          var prev = lbl.getAttribute('data-label') || lbl.textContent;
          lbl.setAttribute('data-label', prev);
          lbl.textContent = 'Copied!';
          link.classList.add('is-copied');
          window.setTimeout(function () {
            lbl.textContent = prev;
            link.classList.remove('is-copied');
          }, 1600);
        }).catch(function () { /* leave the label as-is */ });
      });
    }

    // Merchant-reply toggles: collapsed-by-default, independent per review.
    // Wired once here — filter/sort/pagination never re-touch these elements,
    // so appendChild-based reordering carries the expanded/collapsed state
    // along with the <li> automatically (it moves the existing node, it
    // doesn't recreate it or its listeners).
    var replyToggles = root.querySelectorAll('[data-feefo-replies-toggle]');
    for (var rt = 0; rt < replyToggles.length; rt++) {
      (function (toggle) {
        var content = toggle.nextElementSibling;
        if (!content) return;
        var showLabel = toggle.getAttribute('data-show-label') || 'Show response';
        var hideLabel = toggle.getAttribute('data-hide-label') || 'Hide response';
        content.hidden = true;
        toggle.hidden = false;
        toggle.textContent = showLabel;
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          content.hidden = expanded;
          toggle.setAttribute('aria-expanded', String(!expanded));
          toggle.textContent = expanded ? showLabel : hideLabel;
        });
      })(replyToggles[rt]);
    }

    // Distribution bars: fill in when scrolled into view (the reviews block is
    // typically below the fold). Adds `is-visible`, which the CSS bar-fill keyframe
    // keys off; fires once then unobserves. With no IntersectionObserver or under
    // reduced motion the class is never added and the base CSS shows the bars at
    // full width, so nothing is ever hidden.
    if (motionOK && window.IntersectionObserver) {
      var dist = root.querySelector('.feefo-reviews-native__distribution');
      if (dist) {
        var io = new IntersectionObserver(function (entries, obs) {
          for (var e = 0; e < entries.length; e++) {
            if (entries[e].isIntersecting) {
              entries[e].target.classList.add('is-visible');
              obs.unobserve(entries[e].target);
            }
          }
        }, { threshold: 0.25 });
        io.observe(dist);
      }
    }
  }
})();
  } catch(e) { console.error(e); }
})();

})();
